import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';
import { useYowanAuth } from './YowanAuthContext';

export const useYowanAuthGuard = ({
  requiresAuth = false,
  requiresAdmin = false,
  requiresRelatedSeminars = false,
  requiresBlogAuthor = false,
  search = '',
} = {}) => {
  const { auth } = useYowanAuth();
  const currentUser = auth.currentUser;

  if (!requiresAuth) {
    return {
      auth,
      currentUser,
      status: 'ready',
      notice: null,
    };
  }

  if (currentUser.isAnonymous) {
    return {
      auth,
      currentUser,
      status: 'login-required',
      notice: {
        message:
          '現在は未認証状態です。正式接続後はログインした利用者のみ利用できる想定です。',
        actionHref: appendYowanPreviewQueryIfNeeded('/login', search),
        actionLabel: 'ログイン画面へ',
      },
    };
  }

  if (requiresAdmin && !currentUser.canAccessAdmin) {
    return {
      auth,
      currentUser,
      status: 'admin-required',
      notice: {
        message:
          '管理者権限を確認できませんでした。管理者として登録されているアカウントでログインしてください。',
        actionHref: appendYowanPreviewQueryIfNeeded('/mypage', search),
        actionLabel: 'マイページへ',
      },
    };
  }

  if (requiresRelatedSeminars && !currentUser.canAccessAdmin && !currentUser.canAccessRelatedSeminars) {
    return {
      auth,
      currentUser,
      status: 'related-seminars-required',
      notice: {
        message:
          'このページは担当セミナーを確認する関係者向けのページです。閲覧権限を確認できませんでした。',
        actionHref: appendYowanPreviewQueryIfNeeded('/mypage', search),
        actionLabel: 'マイページへ',
      },
    };
  }

  if (requiresBlogAuthor && !currentUser.canAccessBlogAuthor) {
    return {
      auth,
      currentUser,
      status: 'blog-author-required',
      notice: {
        message:
          'このページはブログ執筆者向けのページです。投稿権限を確認できませんでした。',
        actionHref: appendYowanPreviewQueryIfNeeded('/mypage', search),
        actionLabel: 'マイページへ',
      },
    };
  }

  return {
    auth,
    currentUser,
    status: 'ready',
    notice: null,
  };
};
